import { render, staticRenderFns } from "./form-contact.vue?vue&type=template&id=c1a68b3a&"
import script from "./form-contact.vue?vue&type=script&lang=js&"
export * from "./form-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports